import { useTranslation } from 'react-i18next';
import '../StripCalendar.scss';

const StripCalendarTodayLabel = ({calendarElementWidth, today}) => {  
    const { t } = useTranslation();

    return (
        <div className="c-strip-calendar-event">
            <div className="c-today" style={{width: calendarElementWidth+"%", marginLeft: `${today.index * calendarElementWidth}%`}}>
                <p className="today__lbl">{t('myBlockMonth.today')}</p>
            </div>
        </div>
    )
}

export default StripCalendarTodayLabel;